import { Component, forwardRef, Input, OnChanges, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { InputBaseReactComponent } from '../input-base-react/input-base-react.component';
import { KeyValueModel } from 'app/shared/models/KeyValueModel';
import { DataModel } from 'app/shared/models/DataModel';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'app-input-dropdown-react',
    templateUrl: './input-dropdown-react.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => InputDropDownReactComponent),
            multi: true
        }
    ]
})

export class InputDropDownReactComponent extends InputBaseReactComponent implements ControlValueAccessor, OnInit, OnChanges {

    // atributo utilizado para efetuar preenchimento de itens
    @Input() items: Array<DataModel> = [];
    @Input() keyItems: Array<KeyValueModel> = [];
    @Input() isNumber = false;
    @Input() includeSelectItem = true;
    @Input() customLabelSelect = 'Selecione';

    constructor(
    ) {
        super();
    }

    ngOnInit(): void {
        super.ngOnInit();

        if (this.value) {
            const val = (this.isNumber ? parseInt(this.value.toString(), 0) : this.value.toString());
            if (this.control) {
                this.control.setValue(val);
                this.valorChange.emit(val);
            }
        }
        this.setAndUpdateValidators();
    }

    ngOnChanges(): void {
        super.ngOnChanges();
        this.setAndUpdateValidators();
    }

    public getComboItemText(): string {
        if (this.control) {
            if ((this.items) && (this.items.length > 0)) {
                let item: DataModel;

                try {
                    item = this.items.find(m => m.id.toString() === this.value.toString());
                } catch {

                }

                return (item ? item.nome : '');
            } else
                if ((this.keyItems) && (this.keyItems.length > 0)) {
                    const item: KeyValueModel = this.keyItems.find(m => m.key.toString() === this.value.toString());

                    return (item ? item.value : '');
                } else {
                    return '';
                }
        } else {
            return '';
        }

    }
}
